import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useEffect, useState } from 'react';
import { useSite } from '../../context/site';

function ParentsNoEmailReport() {
    const { GetParentsNoEmailReport } = useSite();

    const [loaded, setLoaded] = useState(false);
    const [parents, setParents] = useState([]);

    // Get parents
    useEffect(() => {
        if (!loaded) {
            GetParentsNoEmailReport({}, (res) => {
                setParents(res.data.parents);
                setLoaded(true);
            });
        }
    }, [loaded, GetParentsNoEmailReport]);

    return (
        <div className="mt-2">
            <DataTable
                value={parents}
                emptyMessage="No parents found"
                showGridlines
                stripedRows
                removableSort
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 25, 50]}
                loading={!loaded}
            >
                <Column field="nameFull" header="Name" sortable></Column>
                <Column field="city" header="Town" sortable></Column>
                <Column field="email" header="Email" sortable></Column>
                <Column field="notes" header="Notes" sortable></Column>
            </DataTable>
        </div>
    );
}

export default ParentsNoEmailReport;
